/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/common/event-emitter.ts" />

module Meevo.Plugins.MarketPricing {

    import MeevoEventEmitter = Meevo.Components.Common.MeevoEventEmitter;

    export interface IContextService  {
        getVisualState(),
        setVisualState(state: Model.MaintenanceFormVisualState, data?: any),
        eventVisualState: MeevoEventEmitter,
        sharedData: any;
    }

    export class ContextService implements IContextService {
        private visualState: Model.MaintenanceFormVisualState = Model.MaintenanceFormVisualState.Search;
        public eventVisualState;
        public sharedData: any;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    ) {
            this.eventVisualState = new MeevoEventEmitter();
        }

        getVisualState () {
            return this.visualState;
        }

        setVisualState (state: Model.MaintenanceFormVisualState, data) {
            if (state === this.visualState) return;

            const prevState = this.visualState;
            this.visualState = state;
            this.sharedData = data;

            this.eventVisualState.emit('changed', state, prevState, data);
        }

        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings, identityService: Meevo.Components.Common.IIdentityService) => {
                return new ContextService(appSettings, identityService);
            };

            svc.$inject = [
                "meevo.AppSettings",
                "meevo.components.common.IdentityService",
            ];
            return svc;
        }
    }

    angular.module("meevo.plugins.marketPricing")
        .factory("meevo.plugins.marketPricing.contextService", ContextService.factory());

}